export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
}

export function groupBy(arr: any[], key: string) {
  return arr.reduce((rv, x) => {
    try {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    } catch (error) {
      return [];
    }
  }, {});
}

export const parseArabicNumbers = (displayValue: string | undefined): any => {
  if (!displayValue) return displayValue;
  return displayValue.replace(/[٠-٩]/g, (d) =>
    "٠١٢٣٤٥٦٧٨٩".indexOf(d).toString(),
  );
};
